import React, { useEffect, useState } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  useForm,
  getField,
  setValue,
  removeLast,
  addRow,
} from "../../common/FormCreatorV2/helpers";
import history from "../../history";
import { postGateForm } from "../../redux/actions/gateActions";

const ReferenceEducationForm = ({ appData, postGateFormFunc }) => {
  let initialData = {};

  const educationInitObj = {
    "Details of Qualification/s Gained": "",
    "From (dd/mm/yy)": "",
    "Name & Address of Schools / Colleges": "",
    "To (dd/mm/yy)": "",
  };

  let initialEducationState = [educationInitObj];

  const trainingInitObj = {
    "Relevant Additional Training / Qualifications (First Aid, Basic Food Hygiene, Fork Lift Truck, etc.)":
      "",
    "From (dd/mm/yy)": "",
    "To (dd/mm/yy)": "",
    "Details of Qualification/s Gained": "",
  };

  let initialTrainingState = [trainingInitObj];

  if (
    appData &&
    appData.gateOnboarding &&
    appData.gateOnboarding.referenceeducation
  ) {
    initialData = {
      ...initialData,
      ...appData.gateOnboarding.referenceeducation,
    };
    if (appData.gateOnboarding.referenceeducation.educationState) {
      initialEducationState = Object.keys(
        appData.gateOnboarding.referenceeducation.educationState
      ).map(
        (key) => appData.gateOnboarding.referenceeducation.educationState[key]
      );
    }
    if (appData.gateOnboarding.referenceeducation.trainingState) {
      initialTrainingState = Object.keys(
        appData.gateOnboarding.referenceeducation.trainingState
      ).map(
        (key) => appData.gateOnboarding.referenceeducation.trainingState[key]
      );
    }
  }

  const [educationState, setEducationState] = useState(initialEducationState);
  const [educationShouldDisable, setEducationShouldDisable] = useState(true);
  const [trainingState, setTrainingState] = useState(initialTrainingState);
  // const [trainingShouldDisable, setTrainingShouldDisable] = useState(true);

  const repeatedDisable = [educationShouldDisable];

  useEffect(() => {
    // TODO clean up
    let areAllFieldsFilled = true;

    educationState.forEach((el) => {
      // check if there are no empty values
      Object.keys(el).forEach((key) => {
        if (!el[key]) {
          areAllFieldsFilled = false;
        }
      });
    });

    if (areAllFieldsFilled && educationState.length >= 1)
      setEducationShouldDisable(false);
    else setEducationShouldDisable(true);
  }, [educationState]);

  // useEffect(() => {
  //   let areAllFieldsFilled = true;

  //   trainingState.forEach((el) => {
  //     // check if there are no empty values
  //     Object.keys(el).forEach((key) => {
  //       if (!el[key]) {
  //         areAllFieldsFilled = false;
  //       }
  //     });
  //   });

  //   if (areAllFieldsFilled && trainingState.length >= 1)
  //     setTrainingShouldDisable(false);
  //   else setTrainingShouldDisable(true);

  // }, [trainingState]);

  const repeatedContent = [
    {
      setValue: setValue(educationState, setEducationState),
      removeLast: removeLast(educationState, setEducationState),
      state: educationState,
      setState: setEducationState,
      add: addRow(educationState, setEducationState, educationInitObj),
      mandatory: true,
    },
    {
      setValue: setValue(trainingState, setTrainingState),
      removeLast: removeLast(trainingState, setTrainingState),
      state: trainingState,
      setState: setTrainingState,
      add: addRow(trainingState, setTrainingState, trainingInitObj),
      mandatory: false,
    },
  ];

  const getVal = getField(initialData);

  const initialState = {
    ReferenceEducation1: {
      title: "Character Reference Details",
      type: "heading",
      textDescription: [
        " Please give details of TWO people who have known you for at least FIVE years and who will be willing to provide a personal character reference for you. Preferably, they should not be previous employers or relatives.",
      ],
    },
    ReferenceEducation2: {
      title: "Character Reference 1",
      type: "heading",
      textDescription: [],
    },
    ReferenceEducation3: {
      title: "Full Name",
      value: getVal("ReferenceEducation3"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation4: {
      title: "Address",
      value: getVal("ReferenceEducation4"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation5: {
      title: "Post Code",
      value: getVal("ReferenceEducation5"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation6: {
      title: "Profession",
      value: getVal("ReferenceEducation6"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation7: {
      title: "Relationship",
      value: getVal("ReferenceEducation7"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation8: {
      title: "E-Mail Address",
      value: getVal("ReferenceEducation8"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation9: {
      title: "Telephone Number",
      value: getVal("ReferenceEducation9"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation10: {
      title: "Character Reference 2",
      type: "heading",
      textDescription: [],
    },
    ReferenceEducation11: {
      title: "Full Name",
      value: getVal("ReferenceEducation11"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation12: {
      title: "Address",
      value: getVal("ReferenceEducation12"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation13: {
      title: "Post Code",
      value: getVal("ReferenceEducation13"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation14: {
      title: "Profession",
      value: getVal("ReferenceEducation14"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation15: {
      title: "Relationship",
      value: getVal("ReferenceEducation15"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation16: {
      title: "E-Mail Address",
      value: getVal("ReferenceEducation16"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation17: {
      title: "Telephone Number",
      value: getVal("ReferenceEducation17"),
      type: "text",
      mandatory: true,
    },
    ReferenceEducation18: {
      title: "Education",
      type: "heading",
      textDescription: [],
    },
    ReferenceEducation19: {
      type: "repeated",
      maxTableRowLength: 5,
      tableDetails: {
        columns: [
          "Name & Address of Schools / Colleges",
          "From (dd/mm/yy)",
          "To (dd/mm/yy)",
          "Details of Qualification/s Gained",
        ],
      },
      tableNumOfMandatoryRows: 1,
      repeatedIndex: 0,
    },
    ReferenceEducation20: {
      title: "Training",
      type: "heading",
      textDescription: [],
    },
    ReferenceEducation21: {
      type: "repeated",
      tableRowLength: 5,
      tableDetails: {
        columns: [
          "Relevant Additional Training / Qualifications (First Aid, Basic Food Hygiene, Fork Lift Truck, etc.)",
          "From (dd/mm/yy)",
          "To (dd/mm/yy)",
          "Details of Qualification/s Gained",
        ],
      },
      tableNumOfMandatoryRows: 0,
      repeatedIndex: 1,
    },
    ReferenceEducation22: {
      title:
        "Additional Information (Please use this space to give brief details of other skills or interests, which you feel may be relevant in support of your application.)",
      value: getVal("ReferenceEducation22"),
      type: "textarea",
      mandatory: false,
    },
    ReferenceEducation23: {
      title:
        "How did you hear about this vacancy / where did you see this post advertised?",
      value: getVal("ReferenceEducation23"),
      type: "textarea",
      mandatory: true,
    },
    ReferenceEducation24: {
      title:
        "Have you got any holidays booked – if yes please supply dates below?",
      value: getVal("ReferenceEducation24"),
      type: "textarea",
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postGateFormFunc("referenceeducation", {
      ...fieldValuesPayload,
      educationState,
      trainingState,
    });

    history.push("/profile/edit/gate-group-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"Reference & Education"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/gate-group-onboarding")}
      repeatedSetValue={setValue(educationState, setEducationState)}
      repeatedRemoveLast={removeLast(educationState, setEducationState)}
      repeatedState={educationState}
      repeatedSetState={setEducationState}
      repeatedAdd={addRow(educationState, setEducationState, educationInitObj)}
      onboardingBranch={"#ADD_BRANCH#"} // <-- TODO
      repeatedContent={repeatedContent}
      repeatedDisable={repeatedDisable}
    />
  );
};

ReferenceEducationForm.propTypes = {
  appData: any,
  postGateFormFunc: func.isRequired,
};

const mapDispatchToProps = {
  postGateFormFunc: postGateForm,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ReferenceEducationForm);
